import { Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { useState } from 'react';

export const CustomCell = ({ formattedValue }: GridRenderCellParams<any, any, any>) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const value = formattedValue ?? '';

  const checkOverflow = (el: HTMLSpanElement | null) => {
    if (el) setShowTooltip(el.scrollWidth > el.clientWidth);
  };
  return (
    <Tooltip
      title={showTooltip ? value : ''}
      arrow
      componentsProps={{
        tooltip: {
          sx: { fontSize: '14px' },
        },
      }}
    >
      <span
        ref={checkOverflow}
        style={{
          padding: '0.5rem',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          display: 'block',
        }}
      >
        {formattedValue}
      </span>
    </Tooltip>
  );
};
